define( function() {
	return ( /\S+/g );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/rnotwhite.js
// module id = 293
// module chunks = 352